import * as React from 'react'
import { toast } from '@sales-center/components'
import {
  getCompanyHeaderDisplaySettings,
  updateCompanyHeaderDisplaySettings,
} from '@user/store/companyHeaderDisplaySettings'
import {
  selectCompanyHeaderDisplaySettings,
  selectCompanyHeaderDisplaySettingsLoading,
  selectCompanyHeaderDisplaySettingsSaving,
  setCompanyHeaderDisplaySettings,
} from '@user/store/companyHeaderDisplaySettings/slice'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useAppSelector } from '@user/store/hooks/useAppSelector'

export const useCompanyHeaderDisplaySettings = () => {
  const dispatch = useAppDispatch()
  const settings = useAppSelector(selectCompanyHeaderDisplaySettings)
  const loading = useAppSelector(selectCompanyHeaderDisplaySettingsLoading)
  const saving = useAppSelector(selectCompanyHeaderDisplaySettingsSaving)

  React.useEffect(() => {
    dispatch(getCompanyHeaderDisplaySettings())
  }, [dispatch])

  const handleToggle = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const previous = settings
    const next = { ...previous, [e.target.name]: e.target.checked }
    dispatch(setCompanyHeaderDisplaySettings(next))
    try {
      await dispatch(updateCompanyHeaderDisplaySettings(next)).unwrap()
    } catch {
      dispatch(setCompanyHeaderDisplaySettings(previous))
      toast.error(
        'Unable to save the header display setting. Please try again.',
      )
    }
  }

  return { settings, disabled: loading || saving, handleToggle }
}
